import { apiGet, apiPost } from '../utils/api'

export const getShopInformationAPI = (groupName) => {
  return apiGet(`mgmt/shopSettings/group/${groupName}?level=SHOP`)
}

export const updateShopInformationAPI = (data, groupName) => {
  return apiPost(`mgmt/shopSettings/update/${groupName}?level=SHOP`, data)
}



// WEBPACK FOOTER //
// ./src/api/shopInformation.js